import _implicitStylesheets from "./helpCenter.css";
import _implicitScopedStylesheets from "./helpCenter.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import _wdsLink from "wds/link";
import _adsIcon from "ads/icon";
import _wdsPopover from "wds/popover";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="help-center-header${0}"${2}><h4 class="help-center-title${0}"${2}>${"t2"}</h4></div>`;
const $fragment2 = parseFragment`<h5 class="news-title${0}"${2}>${"t1"}</h5>`;
const $fragment3 = parseFragment`<h5 class="news-title${0}"${2}>${"t1"}</h5>`;
const $fragment4 = parseFragment`<div class="divider${0}"${2}></div>`;
const $fragment5 = parseFragment`<div class="help-questions-header${0}"${2}><h4 class="help-questions-title${0}"${2}>${"t2"}</h4></div>`;
const $fragment6 = parseFragment`<a href="https://help.salesforce.com/s/" target="_blank"${3}><span class="help-questions-text${0}"${2}>${"t2"}</span></a>`;
const $fragment7 = parseFragment`<a href="https://www.surveymonkey.com/r/PLPJ3WD" target="_blank"${3}><span class="help-questions-text${0}"${2}>${"t2"}</span></a>`;
const stc0 = {
  classMap: {
    "help-center-content": true
  },
  key: 3
};
const stc1 = {
  classMap: {
    "news-container": true
  },
  key: 6
};
const stc2 = {
  "news-card": true
};
const stc3 = {
  "data-testid": "news"
};
const stc4 = {
  "news-text": true
};
const stc5 = {
  "data-testid": "jp-news"
};
const stc6 = {
  key: 19
};
const stc7 = {
  classMap: {
    "help-questions-card": true
  },
  key: 20
};
const stc8 = {
  classMap: {
    "help-questions-icon": true
  },
  props: {
    "symbol": "support"
  },
  key: 21
};
const stc9 = {
  key: 22
};
const stc10 = {
  classMap: {
    "help-questions-card": true
  },
  key: 25
};
const stc11 = {
  classMap: {
    "help-questions-icon": true
  },
  props: {
    "symbol": "feedback"
  },
  key: 26
};
const stc12 = {
  key: 27
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, h: api_element, i: api_iterator, f: api_flatten} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.helpCenterClass),
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleEscapeKey))
    }
  }, [api_custom_element("wds-button", _wdsButton, {
    className: api_normalize_class_name($cmp.openButtonClass),
    props: {
      "ariaLabel": $cmp.labels.openButton,
      "ariaExpanded": $cmp.showPopover,
      "icon": "help",
      "iconSize": "large"
    },
    key: 1,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.togglePopover))
    }
  }), api_custom_element("wds-popover", _wdsPopover, {
    props: {
      "show": $cmp.showPopover
    },
    key: 2,
    on: {
      "close": _m2 || ($ctx._m2 = api_bind($cmp.closePopover))
    }
  }, [api_element("div", stc0, [api_static_fragment($fragment1, 5, [api_static_part(2, null, api_dynamic_text($cmp.labels.title))]), api_element("div", stc1, api_flatten([api_iterator($cmp.news, function (newsItem) {
    return !$cmp.isJapaneseUserLanguage ? api_element("div", {
      classMap: stc2,
      attrs: stc3,
      key: api_key(7, newsItem.iteratorKey)
    }, [api_static_fragment($fragment2, 9, [api_static_part(1, null, api_dynamic_text(newsItem.title))]), api_custom_element("wds-link", _wdsLink, {
      classMap: stc4,
      props: {
        "target": "_blank",
        "i18nMessage": newsItem.text
      },
      key: 10
    })]) : null;
  }), api_iterator($cmp.jpNews, function (jpNewsItem) {
    return $cmp.isJapaneseUserLanguage ? api_element("div", {
      classMap: stc2,
      attrs: stc5,
      key: api_key(11, jpNewsItem.iteratorKey)
    }, [api_static_fragment($fragment3, 13, [api_static_part(1, null, api_dynamic_text(jpNewsItem.title))]), api_custom_element("wds-link", _wdsLink, {
      classMap: stc4,
      props: {
        "target": "_blank",
        "i18nMessage": jpNewsItem.text
      },
      key: 14
    })]) : null;
  })])), api_static_fragment($fragment4, 16), api_static_fragment($fragment5, 18, [api_static_part(2, null, api_dynamic_text($cmp.labels.getHelp.title))]), api_element("div", stc6, [api_element("div", stc7, [api_custom_element("ads-icon", _adsIcon, stc8), api_custom_element("wds-link", _wdsLink, stc9, [api_static_fragment($fragment6, 24, [api_static_part(2, null, api_dynamic_text($cmp.labels.getHelp.supportLink))])])]), !$cmp.isJapaneseUserLanguage ? api_element("div", stc10, [api_custom_element("ads-icon", _adsIcon, stc11), api_custom_element("wds-link", _wdsLink, stc12, [api_static_fragment($fragment7, 29, [api_static_part(2, null, api_dynamic_text($cmp.labels.getHelp.feedbackLink))])])]) : null])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-601bt6lqtn4";
tmpl.legacyStylesheetToken = "undefined-_helpCenter";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
